// extracted by mini-css-extract-plugin
export default {"brand-cobalt":"rgb(64, 36, 211)","tooltipIcon":"styles_tooltipIcon__zjJuh"};